import React, { useRef, useEffect } from "react";
import { useState } from "react";
import { Button, SecTitle, TitleWrap } from "../../components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TeamSMS = ({ ...restProps }) => {
  const contactArea = useRef(null);
  const [lang, setLang] = useState();
  const { t, i18n } = useTranslation();
  const scrollHandler = (event) => {
    event.preventDefault();
    let targetOffset = contactArea.current.offsetTop - 200;
    window.scrollTo({
      behavior: "smooth",
      top: targetOffset,
    });
  };

  window.addEventListener("storage", () => {
    if (localStorage.getItem("cheese_lang")) {
      setLang(localStorage.getItem("cheese_lang"));
    } else {
      setLang("th");
    }
  });

  useEffect(() => {
    if (localStorage.getItem("cheese_lang")) {
      setLang(localStorage.getItem("cheese_lang"));
    } else {
      setLang("th");
    }
  }, []);

  return (
    <div {...restProps}>
      {/* <div className="container mb-100px">
        <TitleWrap>
          <div class="d-flex justify-content-center pt-60px">
            <h1 class="title-line">SMS Solution</h1>
          </div>
          <h2 className="text-d-vision pt-4">
            {t('sms_description')}
          </h2>
        </TitleWrap>
      </div> */}
      {/* <div className="bg-black"> */}
      <div className="bg-white">
        <div className="container pb-100px">
          <div class="d-flex justify-content-center pt-60px">
            <h1 className="title-line text-black">
              SMS Services
            </h1>
          </div> 
          <div className="row pt-4 ">
            <div className="col-lg-4 col-sm-12 p-4 text-center">
               <Link to={`/smssolution-details/sms-marketing`}>
              <div className="sms-img-wrapper">
                <img src="images/sms/sms_01.png" alt="team-member" />
              </div>
              <h3 className="sms-h3 text-black">
                SMS<span> Marketing</span>
              </h3>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-12 p-4 text-center">
              <Link to="/otp-service">
                <div className="sms-img-wrapper">
                  <img src="images/sms/sms_06.png" alt="team-member" />
                </div>
                <h3 className="sms-h3 text-black">
                  SMS OTP
                </h3>
              </Link>
            </div>

            <div className="col-lg-4 col-sm-12 p-4 text-center">
              <Link to={`/smssolution-details/contact-us`}>
              <div className="sms-img-wrapper">
                <img src="images/sms/sms_02.png" alt="team-member" />
              </div>
              <h3 className="sms-h3 text-black">
                E-COUPON
              </h3>
              </Link>
            </div>
            {/* <div className="col-lg-4 col-sm-12 p-4 text-center">
              <div className="sms-img-wrapper">
                <img src="images/sms/sms_03.png" alt="team-member" />
              </div>
              <h3 className="sms-h3 text-black">
                <span>SMS </span>2 WAYS
              </h3>
            </div> */}
          </div>

          <div className="row pt-4">
            <div className="col-lg-4 col-sm-12 p-4 text-center">
              <Link to={`/smssolution-details/contact-us`}>
              <div className="sms-img-wrapper">
                <img src="images/sms/sms_04.png" alt="team-member" />
              </div>
              <h3 className="sms-h3 text-black"  style={{"font-size": "26px"}}>
                SMS 2Way/<span>USSD</span>
              </h3>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-12 p-4 text-center">
              <Link to={`/smssolution-details/contact-us`}>
              <div className="sms-img-wrapper">
                <img src="images/sms/sms_05.png" alt="team-member" />
              </div>
              <h3 className="sms-h3 text-black">
                LBS<br></br> <span style={{"font-size": "26px",color: "black"}}>(Location Base SMS)</span>
              </h3>
              </Link>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamSMS;
